class PdpAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsElements = Array.from(
      this.querySelectorAll('.pdp-accordion details')
    );

    this.detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.pdp-accordion__content');

      details.animation = null;
      details.isClosing = false;
      details.isExpanding = false;

      summary.addEventListener('click', (e) => {
        this.onClick(e, details, summary, content);
      });
    });
  }

  onClick(e, details, summary, content) {
    e.preventDefault();

    details.style.overflow = 'hidden';

    // Close other accordions
    this.detailsElements.forEach((otherDetails) => {
      if (
        otherDetails !== details &&
        otherDetails.open &&
        !otherDetails.isClosing
      ) {
        this.shrink(
          otherDetails,
          otherDetails.querySelector('summary'),
          otherDetails.querySelector('.pdp-accordion__content')
        );
      }
    });

    if (details.isClosing || !details.open) {
      this.open(details, summary, content);
    } else if (details.isExpanding || details.open) {
      this.shrink(details, summary, content);
    }
  }

  shrink(details, summary, content) {
    details.isClosing = true;

    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (details.animation) {
      details.animation.cancel();
    }

    details.animation = details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 350,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'forwards',
      }
    );

    const fadeAnim = content.animate(
      {
        opacity: [1, 0],
        transform: ['translateY(0)', 'translateY(-6px)'],
      },
      {
        duration: 220,
        easing: 'ease-out',
        fill: 'forwards',
      }
    );

    details.animation.onfinish = () => {
      details.open = false;

      if (details.animation) {
        details.animation.cancel();
      }

      fadeAnim.cancel();

      details.animation = null;
      details.isClosing = false;

      details.style.height = '';
      details.style.overflow = '';
    };

    details.animation.oncancel = () => {
      details.isClosing = false;
    };
  }

  open(details, summary, content) {
    details.style.height = `${details.offsetHeight}px`;

    details.open = true;

    window.requestAnimationFrame(() => {
      details.isExpanding = true;

      const startHeight = `${details.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

      if (details.animation) {
        details.animation.cancel();
      }

      details.animation = details.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 350,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards',
        }
      );

      const fadeAnim = content.animate(
        {
          opacity: [0, 1],
          transform: ['translateY(-8px)', 'translateY(0)'],
        },
        {
          duration: 300,
          easing: 'ease-out',
          fill: 'forwards',
        }
      );

      details.animation.onfinish = () => {
        details.open = true;

        if (details.animation) {
          details.animation.cancel();
        }

        fadeAnim.cancel();

        details.animation = null;
        details.isExpanding = false;

        details.style.height = '';
        details.style.overflow = '';
      };

      details.animation.oncancel = () => {
        details.isExpanding = false;
      };
    });
  }
}

customElements.define('pdp-accordion-group', PdpAccordion);